import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function Body({children, ...props}: TypographyProps) {
  return <Typography variant="body1" {...props}>{children}</Typography>
}